export default "__VITE_ASSET__VNIgL$cD__"